import request from '@/utils/request'


// 查询关于我们列表
export function listAboutUs(query) {
  return request({
    url: '/aboutUs/aboutUs/list',
    method: 'get',
    params: query
  })
}

// 查询关于我们分页
export function pageAboutUs(query) {
  return request({
    url: '/aboutUs/aboutUs/page',
    method: 'get',
    params: query
  })
}

// 查询关于我们详细
export function getAboutUs(data) {
  return request({
    url: '/aboutUs/aboutUs/detail',
    method: 'get',
    params: data
  })
}

// 新增关于我们
export function addAboutUs(data) {
  return request({
    url: '/aboutUs/aboutUs/add',
    method: 'post',
    data: data
  })
}

// 修改关于我们
export function updateAboutUs(data) {
  return request({
    url: '/aboutUs/aboutUs/edit',
    method: 'post',
    data: data
  })
}

// 删除关于我们
export function delAboutUs(data) {
  return request({
    url: '/aboutUs/aboutUs/delete',
    method: 'post',
    data: data
  })
}
